import { Navigate, useParams } from 'react-router-dom';

/**
 * 古い /dinosaur/:id パスから /creatures/:documentId パスへのリダイレクトを行うコンポーネント
 * React Router v6では、動的パラメータを含むリダイレクトには専用コンポーネントが必要
 */
const DinosaurRedirector: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  // idパラメータが存在しない場合はホームページにリダイレクト
  if (!id) {
    return <Navigate to="/" replace />;
  }

  // 新しいパス形式にリダイレクト（idをdocumentIdとして渡す）
  return <Navigate to={`/creatures/${id}`} replace />;
};

export default DinosaurRedirector;
